export { default } from "@features/swing-trading/news/screens/news-screen";
